import { call, put, takeEvery } from 'redux-saga/effects';
import { ISalesRepCallGoal, salesRepActionCreators, salesRepActionKeys, SaveSalesRepCallGoals } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { saveSalesRepCallGoals } from '../salesRepApi';

function* saveSalesRepCallGoalsSaga(action: SaveSalesRepCallGoals) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<ISalesRepCallGoal> = yield call(saveSalesRepCallGoals, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(salesRepActionCreators.setSalesRepCallGoals([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveSalesRepCallGoals() {
  yield takeEvery(salesRepActionKeys.SAVE_SALES_REP_CALL_GOALS, saveSalesRepCallGoalsSaga);
}
